<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow

div(class="s12 insety-16 border-bottom")
    div(class="after-16 before-8", :class="{'flex-flex' : $media.l}")
        div(class="text-semibold mf-label") {{ $t('fund_family') }}
        div(:class="$media.l? 'start-32' : 'before-16'")
            SelectDrop(
                ref="selectDrop"
                class="after-16 fund-fields",
                :options="fundFamilies",
                :defaultValue="defaultFundFamily",
                filterFor="family",
                @getSelect="showFundFamily")
</template>

<script>
    import { mapState } from 'vuex'
    import api from '../api/'
    import SelectDrop from './SelectDrop.vue'

    export default {
        name: 'FundFamily',

        components: {
            SelectDrop
        },

        computed: {
            ...mapState('fundscanner', [
                'urlFilters'
            ]),

            defaultFundFamily() {
                return this.initializeData();
            }
        },

        data() {
            return {
                fundFamilies: ['All'],
                selected: 'All'
            }
        },

        methods: {
            getFundFamilies() {
                api.getFundFamilies()
                    .then(res => {
                        this.fundFamilies = [...this.fundFamilies, ...res.families];
                        this.fundFamilies = this.fundFamilies.map(family => family = { value: family, label: family });
                    })
            },

            reset() {
                this.$nextTick(() => {
                    this.$refs.selectDrop.reset();
                    this.selected = 'All';
                });
            },

            showFundFamily(selected) {
                this.selected = selected ? selected: this.defaultFundFamily;
                this.$emit('showFundFamily', this.selected);
            },

            initializeData() {
                return this.urlFilters && this.urlFilters.family ?
                    this.urlFilters.family : 'All';
            }
        },

        mounted() {
            this.selected = this.initializeData();
            this.getFundFamilies();
            this.$emit('showFundFamily', this.selected);
        }
    }
</script>